module.exports = {
   name: 'entity',
   gen_template: `
      {
         "coa": "ASSET",
         "code": "{{random.alphaNumeric}}{{random.number}}{{random.alphaNumeric}}{{random.number}}", 
         "name": "{{lorem.word}}"
      }
   `,
   wizard: {
      actionBtn: 'Save',
      action: 'entity_config',
      pages: [
         {
            title: 'Entity Configuration',
            subtitle: 'Configure new Account entity',
            forms: [
               {
                  type: 'text', form_type: 'text', label: 'Code', model: 'code',
                  validation: 'required|min:2|max:50', class: 'col-12 col-md-6'
               },
               {
                  type: 'text', form_type: 'text', label: 'Name', model: 'name',
                  validation: 'required|min:3|max:150', class: 'col-12 col-md-6'
               },
               {
                  type: 'select', class: 'col-12 col-md-6', model: 'type',
                  options: [
                     { val: 'CLIENT', label: 'CLIENT' },
                     { val: 'UNDERWRITTER', label: 'UNDERWRITTER' },
                     { val: 'BANK', label: 'BANK' },
                  ],
                  validation: 'required', label: 'Types'
               },
               {
                  type: 'select', form_type: 'text', label: 'Sub Type', model: 'sub_type',
                  options: [],validation: 'required', class: 'col-12 col-md-6'
               },
               {
                  type: 'textarea', form_type: 'text', label: 'Description', model: 'description',
                  validation: 'required|min:10|max:500', class: 'col-12'
               },
            ],
         }
      ]
   },
   table: {
      title: 'Entity Configs',
      subtitle: 'A list of configured entities',
      table_fields: [
        { name: 'Entity Type', align: 'c' },
         { name: 'Code', align: 'l' },
         { name: 'Name', align: 'l' },
         { name: 'Sub Type', align: 'c' },
         { name: 'actions', align: 'c' }
      ],
      searchFields: ["entity_code", "entity_name", "entity_type", "entity_sub_type"],
      rowData: [
        { type: 'text', field: 'entity_type', class: 'center small' },
         { type: 'text', field: 'entity_code', class: 'left small' },
         { type: 'text', field: 'entity_name', class: 'left' },
         { type: 'text', field: 'entity_sub_type', class: 'center small' },
         {
            type: 'action', field: 'name', class: 'center', icon: '', actions: [
               // {type: 'title', title: 'Actions'},
               {
                  type: 'menu', title: 'Edit', event: 'client:edit', icon: 'ico-right', params: [
                     { key: 'client', field: '*' }
                  ]
               },
               {
                  type: 'menu', title: 'View', event: 'client:view', icon: 'ico-reply', params: [
                     { key: 'email', field: 'email' },
                     { key: 'name', field: 'name' }
                  ]
               },
               // {type: 'divider'},
               {
                  type: 'menu', title: 'Delete', event: 'client:delete', icon: 'ico-mail-a', params: [
                     { key: 'email', field: 'email' }
                  ]
               },
            ]
         },
      ]
   },
}